import type { CopyShape } from "../../intl";

import type { MENU_LINKS_COPY_PT_BR } from "../menu-links.copy";

export const MENU_LINKS_COPY_ES_ES: CopyShape<typeof MENU_LINKS_COPY_PT_BR> = {
  sections: {
    creativeCommand: "Tu centro creativo",
    ideasStudio: "Estudio de ideas",
    moneyOnTheTable: "Pasta sobre la mesa",
    yourImpact: "Tu impacto",
  },
  links: {
    dashboard: { label: "Panel" },
    agency: { label: "Creators" },
    flow: { label: "Flujo de la semana" },
    calendar: { label: "Calendario" },
    notes: { label: "Notas" },
    tasks: { label: "Centro de contenido" },
    publi: { label: "Centro de campañas" },
    finances: { label: "Finanzas" },
    calculator: { label: "Calculadora de publis", collabLabel: "Propuestas" },
    performance: { label: "Rendimiento" },
  },
  tabLabels: {
    dashboard: "Panel",
    agency: "Creators",
    flow: "Flujo",
    calendar: "Calendario",
    notes: "Notas",
    tasks: "Contenido",
    publi: "Campañas",
    finances: "Finanzas",
    calculator: "Calculadora",
    performance: "Rendimiento",
    proposals: "Propuestas",
  },
  menu: "Menú",
};
